import { styled } from 'styled-components';
import { Col } from 'components/Base/Grid';

export const SCol = styled(Col)<{ $isEmpty?: boolean }>`
  min-width: ${({ $isEmpty }) => $isEmpty && '365px'};
`;

export const EditableSelect = styled.div`
  padding: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: Lato;

  span {
    color: #808080;
  }

  .icon {
    display: none !important;
  }

  &:hover {
    background: #ececec;
    border-radius: 4px;

    .icon {
      display: inline-block !important;
    }
  }
`;

export const CoordinatorTag = styled.div`
  font-family: Lato;
  border-radius: 4px;
  padding: 2.5px 8px;
  border: 1px solid #c8dcde;
  background: #e9f7f7;
  margin-right: 4px;
  line-height: 16px;
  margin-right: 8px;
`;

export const CoordinatorPlaceholder = styled.span`
  font-family: Lato;
  color: #808080;
  margin-left: 8px;
`;
